import { Navigate, useLocation } from 'react-router-dom';
import { useDashboard } from '@/context/DashboardContext';

export default function ProtectedDashboard({ children, adminOnly = false }) {
  const { user, isAdmin } = useDashboard();
  const location = useLocation();
  // Guardamos a dónde iba para volver ahí tras el login (p. ej. /dashboard/eventos)
  if (!user) return <Navigate to="/dashboard/login" replace state={{ from: location.pathname + location.search }} />;
  if (adminOnly && !isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}
